import * as React from "react";
import SingleColumnPage from "../components/lib/Pages/SingleColumnPage/SingleColumnPage";
import PageHeader from "../components/lib/Pages/PageHeader/PageHeader";
import LocatorContainer from "../containers/postshop-locator/PostshopLocatorContainer";
import {ApplicationState} from "../redux/AppStore";
import {Dispatch} from "redux";
import {locatorResultsActions} from "../redux/actions/postshop-locator/locatorResultsActions";
import {locatorSuggestionActions} from "../redux/actions/postshop-locator/locatorSuggestionActions";
import {connect} from "react-redux";
import {locatorMapActions} from "../redux/actions/postshop-locator/locatorMapActions";
import {isEmpty} from 'lodash';
import {MapCoordinate} from "../models/LocatorMap";
import TwoColumnPage from "../components/lib/Pages/TwoColumnPage/TwoColumnPage";
import LocatorMapContainer from "../containers/postshop-locator/LocatorMapContainer";
import queryString from 'query-string';
import {locatorFilterActions} from "../redux/actions/postshop-locator/locatorFilterActions";

interface PostshopLoatorPageProps {
  setFilterRequested: (filterName: string) => void;
  searchRequested: (search: string) => void;
  geolocationSearch: (coord: any) => void;
  locationSearchById: (locationId: string) => void;
  locationSearchByName: (query: string) => void;
  match: any
}

class PostshopLocatorPage extends React.Component<PostshopLoatorPageProps, {}> {
  componentDidMount() {
    this.triggerSearchFromRouterParam();
  }

  shouldComponentUpdate(nextProps: Readonly<PostshopLoatorPageProps>, nextState: Readonly<{}>, nextContext: any): boolean {
    const {q} = queryString.parse(window.location.search);

    if (this.props.match.params.locationIdAndName != nextProps.match.params.locationIdAndName) {
      this.triggerSearchFromRouterParam(nextProps);
      return true;
    } else if (this.props.match.params.locationName != nextProps.match.params.locationName) {
      this.triggerSearchFromRouterParam(nextProps);
      return true;
      //@ts-ignore
    } else if (q && q.length) {
      this.triggerSearchFromRouterParam(nextProps);
      return true;
    }
    return false;
  }

  triggerSearchFromRouterParam(props: any = this.props) {
    let locationIdAndName = props.match.params.locationIdAndName;
    let locationName = props.match.params.locationName;
    const {q} = queryString.parse(window.location.search);

    if (!isEmpty(locationIdAndName)) {
      props.setFilterRequested('');
      props.locationSearchById(locationIdAndName.split('-')[0]);
    } else if (!isEmpty(locationName)) {
      props.locationSearchByName(decodeURIComponent(locationName));
    } else if (q && q.length) {
      //@ts-ignore
      props.locationSearchByName(decodeURIComponent(q));
    } else {
      this.getGeoLocation();
    }
  }

  getGeoLocation() {
    const geolocation = navigator.geolocation;
    new Promise((resolve, reject) => {

      if (!geolocation) {
        reject(new Error('Not Supported'));
      }

      geolocation.getCurrentPosition((position) => {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        this.props.geolocationSearch({latitude, longitude});
      }, () => {
      });
    });
  };

  componentWillMount(): void {
  }

  render() {
    return (
        <TwoColumnPage
            left={<SingleColumnPage
                header={<PageHeader title="Find NZ Post"/>}
                body={<LocatorContainer/>}
            />}
            right={<LocatorMapContainer/>}
        />
    );
  }
}

const mapStateToProps = (state: ApplicationState) => state.postshopLocator.mapState;

/**
 * Map all relevant functions to properties with dispatch events
 *
 * @param dispatch
 */
const mapDispatchToProps = (dispatch: Dispatch) => ({
  setFilterRequested: (filterName: string) => dispatch(locatorFilterActions.setFilterRequested(filterName)),
  searchRequested: (search: string) => dispatch(locatorResultsActions.searchRequested(search)),
  fieldChangedRequested: (search: string) => dispatch(locatorSuggestionActions.fieldChangedRequested(search)),
  locationSearchById: (locationId: string) => dispatch(locatorMapActions.locationSearchById(locationId)),
  locationSearchByName: (query: string) => dispatch(locatorResultsActions.quickSearchRequested(query)),
  geolocationSearch: (geolocationCoords: MapCoordinate) => dispatch(locatorMapActions.geolocationSearch(geolocationCoords)),

});

export default connect(mapStateToProps, mapDispatchToProps)(PostshopLocatorPage);


// WEBPACK FOOTER //
// ./src/pages/PostshopLocatorPage.tsx